<div class="flex-row">
  <div class="flex--row flex__child">
    <div class="selector-with-warning plant-date-control-with-warning">
      <mat-form-field
        [matTooltip]="disabledTooltipText() | translate"
        class="flex__child--auto selector"
        [ngClass]="{
          'date-picker-field-disabled': isPlantDateDisabled(),
          'plant-date-field--warning': plantDateWarningCodes().length > 0,
        }"
        subscriptSizing="dynamic"
      >
        <mat-label class="date-picker-lable">{{ 'blight.blightDetail.plantDate' | translate }}</mat-label>
        <input
          id="blight-plant-date-input"
          [attr.aria-label]="'blight.blightDetail.plantDate' | translate"
          class="date-picker-input"
          matInput
          [matDatepicker]="plantingDatePicker"
          [formControl]="plantingDateFormControl"
          [min]="plantDateLimits.min"
          [max]="plantDateLimits.max"
        />
        <mat-datepicker-toggle matIconSuffix [for]="plantingDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #plantingDatePicker></mat-datepicker>
      </mat-form-field>
      @if (plantDateWarningCodes().length > 0) {
        <app-plant-date-warning [warningCodes]="plantDateWarningCodes()"></app-plant-date-warning>
      }
    </div>

    <mat-form-field
      class="date-picker flex__child--auto selector"
      tabindex="0"
      (click)="openDatePicker(emergenceDatePicker, emergenceDateFormControl, $event)"
      (keydown.enter)="openDatePicker(emergenceDatePicker, emergenceDateFormControl, $event)"
      (keydown.space)="openDatePicker(emergenceDatePicker, emergenceDateFormControl, $event)"
      subscriptSizing="dynamic"
    >
      <mat-label class="date-picker-lable">{{ 'blight.blightDetail.emergenceDate' | translate }}</mat-label>
      <input
        id="blight-emergence-date-input"
        [attr.aria-label]="'blight.blightDetail.emergenceDate' | translate"
        class="date-picker-input"
        matInput
        [matDatepicker]="emergenceDatePicker"
        [formControl]="emergenceDateFormControl"
        [min]="emergenceDateMin"
        [max]="emergenceDateMax"
      />
      <mat-datepicker-toggle matSuffix [for]="emergenceDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #emergenceDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="date-picker flex__child--auto selector"
      tabindex="0"
      (click)="openDatePicker(harvestDatePicker, harvestDateFormControl, $event)"
      (keydown.enter)="openDatePicker(harvestDatePicker, harvestDateFormControl, $event)"
      (keydown.space)="openDatePicker(harvestDatePicker, harvestDateFormControl, $event)"
      subscriptSizing="dynamic"
    >
      <mat-label class="date-picker-lable">{{ 'blight.blightDetail.harvestDate' | translate }}</mat-label>
      <input
        id="blight-harvest-date-input"
        [attr.aria-label]="'blight.blightDetail.harvestDate' | translate"
        class="date-picker-input"
        matInput
        [matDatepicker]="harvestDatePicker"
        [formControl]="harvestDateFormControl"
        [min]="harvestDateMin"
        [max]="harvestDateMax"
      />
      <mat-datepicker-toggle matSuffix [for]="harvestDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #harvestDatePicker></mat-datepicker>
    </mat-form-field>

    <div class="delay-spray-container">
      <mat-form-field class="delay-first-spray flex__child--auto" subscriptSizing="dynamic">
        <mat-label>{{ 'blight.blightDetail.delayFirstSpray' | translate }}</mat-label>
        <mat-select [formControl]="suppressSprayAdviceFormControl">
          <mat-option [value]="false">
            {{ 'no' | translate }}
          </mat-option>
          <mat-option [value]="true">
            {{ 'yes' | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-icon
        class="info-icon ml-2"
        [matTooltip]="'blight.blightDetail.delayFirstSprayInfo' | translate"
        matTooltipPosition="above"
        #tooltip="matTooltip"
      >
        info
      </mat-icon>
    </div>

    <div class="flex__child--auto custom-card" [class.disabled]="!hasBlightAdvices()">
      <div class="header">
        <span>{{ 'blight.blightDetail.pressure' | translate }}</span>
        <span
          [matTooltip]="'blight.blightDetail.pressureInfo' | translate"
          matTooltipPosition="above"
          #tooltip="matTooltip"
          class="info-icon"
        >
          <mat-icon class="info-icon ml-2"> info </mat-icon>
        </span>
      </div>
      <div class="blight-radio-group">
        <label class="radio-low">
          <input
            type="radio"
            name="pressure"
            [formControl]="pressureFormControl"
            [value]="phytophthoraPressureOptions[0]"
          />
          {{ 'blight.blightDetail.pressureOptions.Low' | translate }} <span class="dot green">●</span>
        </label>
        <label class="radio-normal">
          <input
            type="radio"
            name="pressure"
            [formControl]="pressureFormControl"
            [value]="phytophthoraPressureOptions[1]"
          />
          {{ 'blight.blightDetail.pressureOptions.Normal' | translate }} <span class="dot orange">●</span>
        </label>
        <label class="radio-high">
          <input
            type="radio"
            name="pressure"
            [formControl]="pressureFormControl"
            [value]="phytophthoraPressureOptions[2]"
          />
          {{ 'blight.blightDetail.pressureOptions.High' | translate }}<span class="dot red">●</span>
        </label>
      </div>
    </div>
  </div>
</div>
